import { render, staticRenderFns } from "./CompanyHeader.vue?vue&type=template&id=0070da93&scoped=true&"
import script from "./CompanyHeader.vue?vue&type=script&lang=ts&"
export * from "./CompanyHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyHeader.vue?vue&type=style&index=0&id=0070da93&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0070da93",
  null
  
)

export default component.exports